import PropTypes from 'prop-types';

const DepartureMonthFilter = ({ labels, selectedDepartureMonths }) => {
  const numberOfDepMonthSelected = selectedDepartureMonths?.length;
  const filterCount = numberOfDepMonthSelected ? `(1)` : '';
  const isFilterActive = numberOfDepMonthSelected > 0;
  return (
    <>
      <span>{isFilterActive ? `${labels?.departureMonth} ${filterCount}` : `${labels?.departureMonth}`}</span>
    </>
  );
};

DepartureMonthFilter.propTypes = {
  labels: PropTypes.shape({
    departureMonth: PropTypes.string.isRequired,
  }).isRequired,
  selectedDepartureMonths: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DepartureMonthFilter;
